import { AtsVacanciesTableItemPersonFragment } from 'generated/resources/graphql'

import { buildUrl } from 'modules/core/lib/buildUrl'
import { convertDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

const MS_PER_DAY = 1000 * 60 * 60 * 24

export const getDaysDiff = (from: Date, to: Date): number =>
  Math.ceil((to.getTime() - from.getTime()) / MS_PER_DAY)

export const getDaysOpen = (processStartedAt: string | null | undefined): number | null => {
  if (!processStartedAt) return null
  return getDaysDiff(new Date(processStartedAt), new Date())
}

export const getStatusConfig = (status: string) => {
  switch (status) {
    case 'to_do':
      return { label: i18n.t('ats.vacancies.table.status.to_do'), status: 'neutral' }
    case 'in_progress':
      return { label: i18n.t('ats.vacancies.table.status.in_progress'), status: 'info' }
    case 'offer':
      return { label: i18n.t('ats.vacancies.table.status.offer'), status: 'warning' }
    case 'hired':
      return { label: i18n.t('ats.vacancies.table.status.hired'), status: 'positive' }
    case 'cancelled':
      return { label: i18n.t('ats.vacancies.table.status.cancelled'), status: 'critical' }
    default:
      return null
  }
}

export const renderPerson = (person: AtsVacanciesTableItemPersonFragment | null | undefined) => {
  if (!person) return '-'
  return {
    type: 'person' as const,
    value: {
      firstName: person.firstName ?? '',
      lastName: person.lastName ?? '',
      src: buildUrl(person.avatar?.url ?? ''),
    },
  }
}

export const renderDeadline = (deadline: string | null | undefined) => {
  if (!deadline) return '-'
  const diffDays = getDaysDiff(new Date(), new Date(deadline))
  const level: 'critical' | 'warning' | 'info' = diffDays <= 5 ? 'critical' : diffDays <= 12 ? 'warning' : 'info'
  return {
    type: 'alertTag' as const,
    value: {
      label: convertDate(deadline, 'backend', 'ui_abbreviated_month_year'),
      level,
    },
  }
}
